import React, { useState } from "react";
import SortIcon from "@mui/icons-material/Sort";
import { IconButton, Box } from "@mui/material";
import useCustomStyles from "../hooks/CustomStylesHook";
import { useTheme } from "@emotion/react";

interface CustomHeaderProps {
  displayName: string;
  enableSorting?: boolean;
  setSort?: (order: "asc" | "desc") => void;
  showFilterMenu?: boolean;
  applyFilter?: (value: string) => void;
}

const styles = (theme: any) => ({
  mainContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  displayname: {
    fontWeight: "bold",
  },
  iconButton: {
    color: "white",
  },
});

const CustomHeader: React.FC<CustomHeaderProps> = ({
  displayName,
  enableSorting = false,
  setSort,
}) => {
  const theme = useTheme();
  const classes = useCustomStyles(styles, theme);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | null>(null);

  const handleSort = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
    if (setSort) setSort(newSortOrder);
  };

  return (
    <Box className={classes?.mainContainer}>
      <Box component="span" className={classes?.displayName}>
        {displayName}
      </Box>
      <Box className={classes?.sortIconContainer}>
        {enableSorting && (
          <IconButton
            className={classes?.iconButton}
            onClick={handleSort}
            size="small"
          >
            <SortIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default CustomHeader;
